import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { useTranslation } from "react-i18next";

/**
 * The four identifiers an Algerian invoice must carry for each party:
 * RC (registre de commerce), NIF (identification fiscale),
 * NIS (identification statistique) and AI (article d'imposition).
 *
 * Shared by the customer and supplier forms, which both pass changes back as
 * { name, value }.
 */
const FIELDS = [
  { name: 'registration_number', labelKey: 'legal.rc', placeholder: '16/00-1234567 B 24' },
  { name: 'tax_id', labelKey: 'legal.nif', placeholder: '000116001234567' },
  { name: 'nis', labelKey: 'legal.nis', placeholder: '000216001234567' },
  { name: 'tax_article', labelKey: 'legal.taxArticle', placeholder: '16123456789' },
];

export default function LegalIdentifiers({ data, onChangeInput, title = true }) {
  const { t } = useTranslation();

  return (
    <>
      {title && (
        <p className="text-muted small fw-semibold text-uppercase mb-3 mt-2">
          {t('legal.identifiers')}
        </p>
      )}
      <Row>
        {FIELDS.map(field => (
          <Col md="6" lg="3" key={field.name}>
            <FormGroup>
              <Label>{t(field.labelKey)}</Label>
              <Input
                type="text"
                name={field.name}
                value={data?.[field.name] ?? ''}
                onChange={(e) => onChangeInput({ name: field.name, value: e.target.value })}
                placeholder={field.placeholder}
              />
            </FormGroup>
          </Col>
        ))}
      </Row>
    </>
  );
}
